export const mouseRoutes = [
  // Mouse
  {
    path: 'mouse',
    redirect: { name: 'mouse-dpi' },
  },
  {
    path: 'mouse/dpi',
    name: 'mouse-dpi',
    meta: { type: 'mouse' },
    component: () => import('@/views/device/mouse/dpi/index.vue'),
  },
  {
    path: 'mouse/light',
    name: 'mouse-light',
    meta: { type: 'mouse' },
    component: () => import('@/views/device/mouse/light/index.vue'),
  },
  {
    path: 'mouse/keys',
    name: 'mouse-keys',
    meta: { type: 'mouse' },
    component: () => import('@/views/device/mouse/keys/index.vue'),
  },
  {
    path: 'mouse/rt',
    name: 'mouse-rt',
    meta: { type: 'mouse' },
    component: () => import('@/views/device/mouse/rt/index.vue'),
  },
  {
    path: 'mouse/performance',
    name: 'mouse-performance',
    meta: { type: 'mouse' },
    component: () => import('@/views/device/mouse/performance/index.vue'),
  },
  {
    path: 'mouse/parameters',
    name: 'mouse-parameters',
    meta: { type: 'mouse' },
    component: () => import('@/views/device/mouse/parameters/index.vue'),
  },
  {
    path: 'mouse/settings',
    name: 'mouse-settings',
    meta: { type: 'mouse' },
    component: () => import('@/views/device/mouse/settings/index.vue'),
  },
]
